import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_2 = { class: "about-reppon-container" }
const _hoisted_3 = { style: {"overflow":"hidden"} }
const _hoisted_4 = { style: {"height":"100%"} }
const _hoisted_5 = { style: {"height":"100%","word-wrap":"break-word","position":"relative"} }
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = { style: {"color":"#ebebf3"} }
const _hoisted_8 = { style: {"font-size":"54px"} }
const _hoisted_9 = { style: {"font-size":"36px"} }

import { nextTick } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'FontOverlay',
  props: {
  // 后方的字
  backendFont: String,
  // 前面的字
  frontEndFont: String,
  // 控制动画类名
  className: String,
},
  setup(__props) {

const props = __props;
function addCSS() {
  // 创建一个 <style> 标签
  const style = document.createElement("style");
  style.type = "text/css";

  // 定义要添加的 CSS 代码
  const css = `
        .${props.backendFont} {
          transform: scale(0);
          transition: transform 1.5s ease-out;
        }
        .${props.backendFont}.hide {
          transform: scale(1);
        }
        .${props.className} {
          transform: scale(0);
          transition: transform 0.5s ease-out;
        }
        .${props.className}.hide {
          transform: scale(1);
        }
      `;

  // 将 CSS 代码插入 <style> 标签
  if (style.styleSheet) {
    // 兼容 IE
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  // 将 <style> 标签插入 <head> 中
  document.head.appendChild(style);
}
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(`.${props.backendFont}`);
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("hide");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(`.${props.className}`);
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("hide");
    }
  }
});
nextTick(() => {
  addCSS();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", {
                    class: _normalizeClass(props.backendFont),
                    style: {"font-family":"Arial Black, serif"}
                  }, _toDisplayString(props.backendFont), 3)
                ])
              ]),
              _createElementVNode("strong", null, [
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", {
                    style: {"font-family":"Arial Black, sans-serif","position":"absolute","left":"35%","top":"20%"},
                    class: _normalizeClass(props.className)
                  }, _toDisplayString(props.frontEndFont), 3)
                ])
              ])
            ])
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { style: {"width":"80px","height":"7px","background-color":"#1364e9","margin-left":"39%"} }, null, -1))
        ])
      ])
    ])
  ]))
}
}

})